import * as actionTypes from '../actions/types';

const initialState = {
    internacion: {
        id: null,
        tempId: null,
        nroInternacion: null,
        nroSocio: null,
        nombreCompleto: '',
        nroDocumento: null,
        bajaLogica: false,
        detalles: [],
    },
    internacion_actualizar: null,
};

export function internacionesReducer(state = initialState, action) {
    const _internacion = { ...state.internacion };

    switch (action.type) {
        case actionTypes.RECUPERAR_INFO_NRO_INTERNACION:
            return {
                ...state,
                internacion: { ..._internacion, ...action.payload },
            };
        case actionTypes.REINICIAR_DATOS_INTERNACION:
            return {
                ...state,
                internacion: {
                    id: null,
                    tempId: null,
                    nroInternacion: null,
                    nroSocio: null,
                    nombreCompleto: '',
                    nroDocumento: null,
                    bajaLogica: false,
                    detalles: [],
                },
            };
        case actionTypes.ACTUALIZAR_NUEVA_INTERNACION:
            return {
                ...state,
                internacion: { ...action.payload },
            };
        case actionTypes.GUARDAR_TEMP_ID:
            _internacion.tempId = action.payload;
            return {
                ...state,
                internacion: _internacion,
            };
        case actionTypes.AGREGAR_ARCHIVO_NUEVA_INTERNACION:
            _internacion.detalles.concat([{ ...action.payload }]);
            return {
                ...state,
                internacion: _internacion,
            };
        case actionTypes.INTERNACION_PARA_ACTUALIZAR:
            return {
                ...state,
                internacion_actualizar: { ...action.payload },
            };
        case actionTypes.RESET_INTERNACION_PARA_ACTUALIZAR:
            return {
                ...state,
                internacion_actualizar: null,
            };
        default:
            return state;
    }
}
